const machine_txt = {
    type: "VA-S800 Max",
    name: "Intelligent Stepping Motor Computerized Overlock Machine",
    description: [
        "APPLICATION",
        "Suitable for clothing, underwear, bedding and thin packaging fabrics overlap seams, decorative seams, in ddition to a variety of stitches to choose from.",
        "FEATURES",
        "The stepper motor bidirectionally controls the lifting and pressing of the foot and the cutting of the wire, achieving ultra-quiet operation. More durable.",
        "The response time for lifting and pressing the feet and cutting the wire is faster, and the wire ends are shorter",
        "Optimize the stroke structure of the needle rod, the upward curved needle remote rod and the feeding CAM mechanism to truly achieve the ability to handle both thick and thin materials",
        
    ],
    //绝对路径
    machine_img:[
        "/assets/machine/7/machine_img/1.jpg",
    ],
    machine_other_img:[
        "/assets/machine/7/machine_other/1.png",
    ]
}
export default {machine_txt}